<template>
    <main class="main about-brand-page">
        <section class="sec-about">
            <div class="container">
                <div class="about-brand-page__banner">

                    <picture class="img-element">


                        <img src="https://batnorton.com/img/about1.webp" class="img-element" alt="">
                    </picture>
                </div>
                <h1 class="about-brand-page__title">
                    {{ trans("Introducing Bat Norton® — a combination of quality and creativity") }}.
                </h1>
                <div class="store-body__video-container">
                    <div class="video-box">
                        <video id="video" muted="muted" loop="loop" playsinline="" class="img-element">
                            <source src="https://batnorton.com/videos/66bdd5d552b08.mp4" type="video/mp4">
                        </video>
                        <div id="video-btn" class="video__play" @click="videoPlay" v-show="icon_play">
                            <svg class="svg-icon" width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect y="0.5" width="48" height="48" rx="24" fill="white"></rect>
                                <path d="M31.3328 24.4999L20.666 16.5V32.5L31.3328 24.4999Z" fill="black"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="welcome-sec__advantages">
                    <h3 class="welcome-sec__advantages-title">
                        {{
                            trans("We use premium materials to create clothes that combine comfort and style")
                        }}.
                    </h3>
                    <div class="welcome-sec__advantages-row">
                        <div class="welcome-sec__advantages-element">
                            <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.791 9.75L11.291 15L8.54102 12.375" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M12.666 21C17.6366 21 21.666 16.9706 21.666 12C21.666 7.02944 17.6366 3 12.666 3C7.69545 3 3.66602 7.02944 3.66602 12C3.66602 16.9706 7.69545 21 12.666 21Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>

                            <p class="text-element">{{ trans('Unique design') }}</p>
                        </div>
                        <div class="welcome-sec__advantages-element">
                            <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.791 9.75L11.291 15L8.54102 12.375" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M12.666 21C17.6366 21 21.666 16.9706 21.666 12C21.666 7.02944 17.6366 3 12.666 3C7.69545 3 3.66602 7.02944 3.66602 12C3.66602 16.9706 7.69545 21 12.666 21Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>

                            <p class="text-element">{{ trans('Own production') }} </p>
                        </div>
                        <div class="welcome-sec__advantages-element">
                            <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.791 9.75L11.291 15L8.54102 12.375" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M12.666 21C17.6366 21 21.666 16.9706 21.666 12C21.666 7.02944 17.6366 3 12.666 3C7.69545 3 3.66602 7.02944 3.66602 12C3.66602 16.9706 7.69545 21 12.666 21Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>

                            <p class="text-element">{{ trans("Delivery") }}</p>
                        </div>
                    </div>
                </div>
                <div class="about-brand-page__posts">
                    <div class="about-brand-page__post">
                        <div class="about-brand-page__post-img">
                            <picture>

                                <img src="https://batnorton.com/img/about2.webp" class="img-element" alt="">
                            </picture>
                        </div>
                        <div class="about-brand-page__post-text">
                            <p class="text-element">
                                {{
                                    trans("Thanks to our production center and a special design bureau, each product requires careful processing, which ensures a unique design and a perfect fit")
                                }}
                            </p>
                            <p class="text-element">
                                {{trans("By guiding the entire production process from the initial sketch to the final product, we remain committed to the quality of each garment. Our collection features exclusive designer items such as kimono jackets and jackets with pointed shoulders, in harmony with fashion, functionality and original Asian flavor")}}.
                            </p>
                        </div>
                    </div>
                    <div class="about-brand-page__post">
                        <div class="about-brand-page__post-img">
                            <picture>

                                <img src="https://batnorton.com/img/about3.webp" class="img-element" alt="">
                            </picture>
                        </div>
                        <div class="about-brand-page__post-text">
                            <p class="text-element">
                                {{trans("Our brand is based on versatility, which allows you to create unique images for any occasion. Taking into account the trends of agenderism, we offer a variety of unisex models, challenging stereotypes and celebrating the richness of Asian fashion and traditions")}}.</p>
                            <p class="text-element">
                                {{trans("The mission of Bat Norton® is to enable creative people to express themselves through comfortable and stylish clothes")}}.</p>
                        </div>
                    </div>
                </div>
                <div class="about-brand-page__network-wrapper">
                    <p class="text-element">{{trans("Join us in a world where quality, innovation and self-expression converge")}}.</p>
                    <div class="about-brand-page__networks-row">
                        <a class="about-brand-page__network-link" href="https://www.instagram.com/batnorton?igsh=MTk5eGdsOTZzdDRrMQ==k">

                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="32" height="32"><path fill="#fff" d="M 16.5 5 C 10.159 5 5 10.159 5 16.5 L 5 31.5 C 5 37.841 10.159 43 16.5 43 L 31.5 43 C 37.841 43 43 37.841 43 31.5 L 43 16.5 C 43 10.159 37.841 5 31.5 5 L 16.5 5 z M 34 12 C 35.105 12 36 12.895 36 14 C 36 15.104 35.105 16 34 16 C 32.895 16 32 15.104 32 14 C 32 12.895 32.895 12 34 12 z M 24 14 C 29.514 14 34 18.486 34 24 C 34 29.514 29.514 34 24 34 C 18.486 34 14 29.514 14 24 C 14 18.486 18.486 14 24 14 z M 24 17 A 7 7 0 1 0 24 31 A 7 7 0 1 0 24 17 z"></path></svg>
                        </a>

                    </div>
                </div>

                <div class="about-brand-page__banner2">
                    <div class="about-brand-page__namer2-img">
                        <picture>
                            <source srcset="https://batnorton.com/img/about4.webp" type="image/webp">
                            <img src="https://batnorton.com/img/about4.webp" class="img-element" alt="">
                        </picture>
                    </div>
                    <div class="sec-title-container">
                        <p class="sec-title-container__dop-text">Bat Norton</p>

                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
export default {
    name: "index",
    methods:{
        videoPlay(){
            $('#video').get(0).play()
            $(this).remove()
            this.icon_play = false
        },
    },
    data(){
        return{
            icon_play:true,
        }
    }
}
</script>

<style scoped>

</style>
